const config = {
  id: 29,
  name: '专场活动',
  type: 1,
  module_code: 'active_special', // bind的配置文件
  icon: 'icon-tms-red-packet',
  font_icon: '&#xe60f;',
  style_type: 1,
  link_type: 0,
  property_data: {
    type: 1,
    item_bg: ['#FFD9CB', '#FFEFE8'],
  }
};

export default config;


